"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(ip, port) {
    return ['CLUSTER', 'MEET', ip, port.toString()];
}
exports.transformArguments = transformArguments;
